import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Modal } from "../components/Modal";
import { store } from "../stores/Store";
import './PreviewModal.scss';
import Loader from "../components/Loader.jsx";
import Img from "../components/Img.jsx";
import LogoLoader from "../components/LogoLoader.jsx";
import ZoomablePreview from "../components/ZoomablePreview.jsx";
import { useWindowSize } from "../effects/useWindowSize.js";

const PreviewModal = observer(() => {
    const [isLoading, setIsLoading] = useState(true);
    const { width } = useWindowSize();

    const imageUrl = store.previewImageUrl;
    const allowZoom = store.previewAllowZoom && width < 1200;

    useEffect(() => {
        const img = new Image();
        img.onload = () => {
            setIsLoading(false);
        }
        img.src = imageUrl;

    }, [imageUrl]);

    return (
        <Modal
            className={`no-padding modal-${store.previewSize} modal-aspect-${store.previewAspectRatio}`}
            style={{ zIndex: 9999 }}
            onClose={e => {
                store.closePreview();
            }}
            isOpen={store.isPreviewOpen}

        >
            <div className={`PreviewModal ${allowZoom ? "PreviewModal--zoomable" : ""}`}>
                {isLoading ? <div className="PreviewModal__loader">
                    <LogoLoader visible />
                </div> : allowZoom ? <ZoomablePreview src={store.previewImageUrl} /> : <Img loader={<LogoLoader visible />} src={store.previewImageUrl} className="d-block m-auto w-100 PreviewModal__image" alt="" />
                }
            </div>
        </Modal>
    )
});
PreviewModal.displayName = "PreviewModal";

export default PreviewModal